import {
  Component,
  Input,
  Output,
  HostListener,
  EventEmitter,
  OnInit
} from "@angular/core";
import { Card, TokenTemplates } from "./models/card.model";
import { FormControl } from "@angular/forms";
import { imagesUrlPrefix } from "../../../../../marvel-champions/models/catalog.model";

export enum CardSide {
  FRONT = "front",
  BACK = "back"
}

@Component({
  selector: "app-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"]
})
export class CardComponent implements OnInit {
  @Input()
  lang: "en" | "fr";

  @Input()
  card: Card;

  @Input()
  size; // xlarge

  @Input()
  forcePortrait = false;

  private _openTokenModal: boolean;
  tokens = new FormControl();

  get openTokenModal(): boolean {
    return this._openTokenModal;
  }

  set openTokenModal(openTokenModal: boolean) {
    this.modalTmpTokens = [...this.tokensSelected];
    this._openTokenModal = openTokenModal;
    this.draggable.emit(!openTokenModal);
  }

  tokensSelected: any[];
  tokenTemplates: any[] = [
    TokenTemplates.EMPTY,
    TokenTemplates.STUNT,
    TokenTemplates.ENRAGE,
    TokenTemplates.WARD,
    TokenTemplates.SIMPLE_RED,
    TokenTemplates.SIMPLE_GREEN,
    TokenTemplates.SIMPLE_YELLOW
  ];
  modalTmpTokens; // tokens selected in the modal

  @Input()
  actions: {
    zoomable: boolean;
    rotable: boolean;
    toggleSide: boolean;
    shufflable: boolean;
    tokens: boolean;
  } = {
    zoomable: true,
    rotable: true,
    toggleSide: false,
    shufflable: false,
    tokens: true
  };

  @Input()
  defaultSide: CardSide = CardSide.FRONT; // true CardSide.FRONT, false CardSide.BACK

  @Output()
  actionZoom: EventEmitter<any> = new EventEmitter(); // TODO type

  @Output()
  actionShuffle: EventEmitter<any> = new EventEmitter(); // TODO type

  @Output()
  actionToken: EventEmitter<any> = new EventEmitter(); // TODO type

  @Output()
  actionClickBody: EventEmitter<any> = new EventEmitter(); // TODO type

  @Output()
  actionRotate: EventEmitter<any> = new EventEmitter();

  @Output()
  actionToggleSide: EventEmitter<any> = new EventEmitter();

  @Output()
  draggable: EventEmitter<boolean> = new EventEmitter();

  @Output()
  actionSelectTokens: EventEmitter<any> = new EventEmitter();

  @Output()
  action: EventEmitter<any> = new EventEmitter();

  @Output()
  actionAttachments: EventEmitter<any> = new EventEmitter();

  selectedIndexes = [];

  ngOnInit() {
    this.initSelectedTokens();
    // this.card.attachments = ['foo'];
  }

  // TODO do it only for displayed card (not for deck, discard etc)
  initSelectedTokens() {
    this.tokensSelected = new Array(3);
    if (this.card['tokens']) {
      let index = 0;
      for (let [key, value] of Object.entries(this.card['tokens'])) {
        if (index <= 2 && index >= 0) {
          this.tokensSelected[index] = key;
        }
        index++;
      }
    }
    /* this.tokensSelected = [TokenTemplates.SIMPLE_RED, TokenTemplates.SIMPLE_GREEN, TokenTemplates.SIMPLE_YELLOW]; */
  }

  toggleShowCardModal() {
    this.actionZoom.emit();
  }

  toggleRotate() {
    this.actionRotate.emit();
  }

  toggleSide() {
    // this.side = this.side === CardSide.FRONT ? CardSide.BACK : CardSide.FRONT;
    this.actionToggleSide.emit();
  }

  clickBody() {
    this.actionClickBody.emit();
  }

  isSelected(index): boolean {
    return this.selectedIndexes.findIndex(i => i === index) > -1;
  }

  toggleSelected(index: number) {
    const selectedIndex = this.selectedIndexes.findIndex(i => i === index);
    if (selectedIndex === -1) {
      this.selectedIndexes.push(index);
    } else {
      this.selectedIndexes.splice(selectedIndex, 1);
    }
  }

  ngClass(index): string {
    const selected = this.isSelected(index) ? "selected" : "";
    return "attachment" + index + " " + selected;
  }

  getBackground(card: Card): string {
    if (!card) {
      return null;
    } else {
      /* return this.defaultSide === CardSide.BACK ? `url(${card.images.back})` : `url(${card.images.front})`; */
      if (card["actions"] && card["actions"]["toggleSide"]) {
        return `url(${imagesUrlPrefix(this.lang)}${
          card.images[card["actions"]["toggleSide"]]
        })`;
      } else {
        return this.defaultSide === CardSide.BACK
          ? `url(${imagesUrlPrefix(this.lang)}${card.images.back})`
          : `url(${imagesUrlPrefix(this.lang)}${card.images.front})`;
      }
    }
  }

  shuffle() {
    this.actionShuffle.emit();
  }

  changeCounterEventReceiver(event) {
    this.actionToken.emit({ card: this.card, counterChangeEvent: event });
  }

  selectTokenTemplate(i: number, tokenTemplate: TokenTemplates) {
    function isTokenAlreadySelectedInOtherSlot(tokensSelected): number {
      let result;
      const currentSelectedTokenAtIndex = tokensSelected[i];
      const isTokenAlreadySelectedInOtherSlot = tokensSelected.findIndex(
        tokenTemplateFilter => tokenTemplateFilter === tokenTemplate
      );
      return isTokenAlreadySelectedInOtherSlot;
    }

    const indexIfAlreadySelectedInOtherSlot = isTokenAlreadySelectedInOtherSlot(
      this.modalTmpTokens
    );
    if (indexIfAlreadySelectedInOtherSlot >= 0) {
      this.modalTmpTokens[indexIfAlreadySelectedInOtherSlot] =
        TokenTemplates.EMPTY;
    }
    this.modalTmpTokens[i] = tokenTemplate;
  }

  saveSelectedTokensTemplate() {
    this.tokensSelected = this.modalTmpTokens;
    const newTokens = {};

    if (!this.card['tokens']) {
      this.card['tokens'] = {};
    }

    for (let tokenSelected of this.tokensSelected) {
      newTokens[tokenSelected] = this.card['tokens'][tokenSelected]
        ? this.card['tokens'][tokenSelected]
        : 0;
    }
    this.card['tokens'] = newTokens;
    this.actionSelectTokens.emit();
    this.openTokenModal = false;
  }

  attachmentsAction() {
    this.actionAttachments.emit();
  }

  isLandScape() {
    let result: boolean;
    result =
      this.forcePortrait ||
      (!this.forcePortrait &&
        (this.card &&
          this.card.metadatas &&
          this.card.metadatas.orientation === "landscape"));
    return result;
  }
}
